import React, { Component } from 'react';
import StockPayment_pythonApi from './StockPayment_pythonApi'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { firebaseAuth, logComponentLoad } from '../../../../config/constants'

class PaymentsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            algoliaUser:''
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })
                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);
                }
            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })
    }


    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject,null,3));

        // logComponentLoad(returnObject, componentName, email) {
        logComponentLoad(returnObject, "PaymentsPage");


        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    render() {

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.paymentsPage
            ? <div>
                <StockPayment_pythonApi type="stockPayments" />
                <StockPayment_pythonApi type="printingCharges" />
            </div>
            : <h4>loading error</h4>

        return (<div>
            {wholeUI}
        </div>);
    }
}

export default PaymentsPage;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/PaymentsPage.js